import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import { ApiURL } from "constants/constants";
import { useParams } from "react-router-dom";
import DefaultUser from "assets/images/default/default-user.png";
import { useDispatch, useSelector } from "react-redux";
import {
  changeUserAgentRequestAction,
  getUserInfo,
} from "redux/actions/usersActions";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Autocomplete from "components/Autocomplete";
import { getAgentsListRequestAction } from "redux/actions/agentActions";
import Button from "components/Button";
import BadgeIcon from "@mui/icons-material/Badge";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

const ProfileHeader = () => {
  const dispatch = useDispatch();
  const { id: userId } = useParams();
  const [user, setUser] = useState({});
  const [agent, setAgent] = useState(null);
  const [open, setOpen] = useState(false);
  const agents = useSelector((state) => state.agent.agentsList);

  useEffect(() => {
    if (userId) dispatch(getUserInfo({ setUser, userId }));
  }, [userId]);

  useEffect(() => {
    dispatch(getAgentsListRequestAction());
  }, []);

  const editAgentDialog = (
    <Dialog open={open}>
      <DialogTitle>Edit Agent</DialogTitle>
      <DialogContent>
        <Autocomplete
          options={agents}
          defaultValue={user.agent}
          // value={agent}
          getOptionLabel={(option) => option.name}
          onChange={(e, value) => setAgent(value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          text={"Save"}
          onClick={() =>
            dispatch(
              changeUserAgentRequestAction({
                agentId: agent.id,
                userId,
                onSuccess: () => {
                  dispatch(getUserInfo({ setUser, userId }));
                  setOpen(false);
                },
              })
            )
          }
        />
        <Button
          text={"Cancel"}
          variant="outlined"
          onClick={() => setOpen(false)}
        />
      </DialogActions>
    </Dialog>
  );

  return (
    <div className="jr-profile-banner">
      <div className="jr-profile-container">
        <div className="jr-profile-banner-top">
          <div className="jr-profile-banner-top-left">
            <div className="jr-profile-banner-avatar ml-3">
              <Avatar
                className="size-90"
                alt="..."
                src={
                  user?.profilePicture
                    ? ApiURL + user?.profilePicture
                    : DefaultUser
                }
              />
            </div>
            <div className="jr-profile-banner-avatar-info">
              <h2 className="mb-2 jr-mb-sm-3 jr-fs-xxl jr-font-weight-light">
                {user?.firstName} {user?.lastName}
              </h2>
              <p className="mb-1 text-grey">
                <BadgeIcon /> Pep Id: {user.pepId}
              </p>
              <p className="mb-1 text-grey">
                <PendingActionsIcon /> Pep Status: {user.pepStatus}
              </p>
              <p className="mb-1 text-grey">
                <SupportAgentIcon /> Agent: {user.agentName}{" "}
                <IconButton
                  color="white"
                  onClick={() => setOpen(true)}
                  sx={{ p: 0 }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </p>
            </div>
          </div>
          <div className="jr-profile-banner-top-right">
            <ul className="jr-follower-list">
              <li>
                <span className="jr-follower-title jr-fs-lg jr-font-weight-medium">
                  {user?.user_plan && user?.user_plan.plan.name_en}
                </span>
                <span className="jr-follower-title jr-fs-lg jr-font-weight-medium">
                  {user?.user_plan && user?.user_plan.end_date}
                </span>
                {user?.promoter_email && (
                  <a
                    target="_blank"
                    href={`/app/profile/user/${user?.promoter_id}/Summary`}
                    style={{ textDecoration: "none", color: "white" }}
                    rel="noreferrer"
                  >
                    <span className="jr-fs-sm d-block pointer mt-3">
                      Promoter Email{": "}
                      {user?.promoter_email}
                    </span>
                  </a>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
      {editAgentDialog}
    </div>
  );
};

export default React.memo(ProfileHeader);
